function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { Typography } from 'seagull/components/Typography';
import AddAdditionalRecipients from "../../../../components/AgreementStudio/AddAdditionalRecipients/AddAdditionalRecipients";
import pluralize from 'pluralize';
import { validateReviewers } from "../../../../business-logic/draftLogic";
import { useSignal } from "../../../../hooks/useSignal";
export default function AdditionalRecipientsCell(_ref) {
  let {
    draft,
    contact,
    index,
    onOpenModal
  } = _ref;
  const [showReviewerErrors, signalShowReviewerErrors] = useSignal();
  const numReviewers = draft.reviewers.length;
  const primaryContact = contact || undefined;
  return /*#__PURE__*/React.createElement(EditableTableCell, {
    testid: "edit-additional-recipients-".concat(index),
    onClick: () => onOpenModal({
      width: '800px',
      shouldSubmit: draft => {
        const isValid = validateReviewers(draft.reviewers, primaryContact);
        if (!isValid) {
          signalShowReviewerErrors(true);
        }
        return isValid;
      },
      renderContent: _ref2 => {
        let {
          draft,
          setDraft
        } = _ref2;
        return {
          title: 'Additional recipients',
          testid: "edit-additional-recipients-modal",
          content: /*#__PURE__*/React.createElement(AddAdditionalRecipients, {
            initialState: draft.reviewers,
            showReviewerErrors: showReviewerErrors,
            primaryContact: primaryContact,
            onChange: newReviewers => setDraft(_objectSpread(_objectSpread({}, draft), {}, {
              reviewers: newReviewers
            }))
          })
        };
      }
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "additional-recipients-".concat(index)
  }, numReviewers ? pluralize('additional recipient', numReviewers, true) : ''));
}